import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import AddCustomField from 'app/form/AddCustomField';
import { toggleModal } from 'reducers/UiReducer';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '1px solid #000',
	boxShadow: 24,
	p: 4,
	borderRadius: 5,
};

export default function BasicModal() {
	const [open, setOpen] = React.useState(false);
	const dispatch = useDispatch();
	const handleOpen = () => setOpen(true);
	const handleClose = () => dispatch(toggleModal(false));
	const { modal } = useSelector((state) => state.ui);

	return (
		<div>
			<Modal
				open={modal}
				onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'>
				<Box sx={style}>
					<AddCustomField />
				</Box>
			</Modal>
		</div>
	);
}
